import Loadable from '../../components/loadable';

const ManageWebsiteMobileAppAccess = Loadable({
  loader: () => import('../../pages/manage_website/mobile_app_access'),
});

angular.module('gym').value('ManageWebsiteMobileAppAccess', ManageWebsiteMobileAppAccess);
